// ============================================
// NOTIFICATION SERVICE (Frontend) — F22A + FIX
// ============================================
// API client para notificaciones de BiLeads
// ✅ FIX: baseURL ahora usa /api/notificaciones (consistente con adminService)
// ============================================

import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

const notifAPI = axios.create({
  baseURL: `${API_URL}/notificaciones`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Interceptor: agregar token
notifAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

notifAPI.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error('Error en Notification API:', err.response?.status, err.response?.data || err.message);
    return Promise.reject(err);
  }
);

/**
 * Obtener notificaciones paginadas
 */
export const getNotificaciones = async ({ page = 1, limit = 20, soloNoLeidas = false, categoria = null } = {}) => {
  const params = { page, limit, soloNoLeidas };
  if (categoria) params.categoria = categoria;
  const response = await notifAPI.get('/', { params });
  return response.data;
};

/**
 * Contar notificaciones no leídas
 */
export const getNotificacionesCount = async () => {
  const response = await notifAPI.get('/count');
  return response.data.count;
};

/**
 * ✅ BLOQUE NOTIF: Contar no leídas por categoría
 * Returns { total, urgentes, servicios, informativas }
 */
export const getCountCategorias = async () => {
  const response = await notifAPI.get('/count-categorias');
  return response.data;
};

/**
 * Marcar una notificación como leída
 */
export const marcarLeida = async (notificacionId) => {
  const response = await notifAPI.put(`/${notificacionId}/leer`);
  return response.data;
};

/**
 * Marcar todas las notificaciones como leídas
 */
export const marcarTodasLeidas = async () => {
  const response = await notifAPI.put('/leer-todas');
  return response.data;
};

/**
 * Helper: ícono por tipo de notificación
 */
export const getNotifIcon = (tipo) => {
  const icons = {
    LEAD_CALIFICADO: '🔥',
    BOT_COMPLETADO: '📋',
    FOLLOW_UP_ENVIADO: '📩',
    SPEED_TO_LEAD: '⏰',
    FOLLOW_UP_PENDIENTE: '⏳',
    RECORDATORIO: '⏰',
    LEAD_RECHAZADO_ZONA: '🚫',
    SERVICIO_PENDIENTE: '🔧',
    SERVICIO_PENDIENTE_AGRUPADO: '🔧',
    LIFECYCLE_PENDIENTE: '📋'
  };
  return icons[tipo] || '🔔';
};

/**
 * Helper: color por tipo
 */
export const getNotifColor = (tipo) => {
  const colors = {
    LEAD_CALIFICADO: '#ef4444',
    BOT_COMPLETADO: '#06b6d4',
    FOLLOW_UP_ENVIADO: '#f59e0b',
    SPEED_TO_LEAD: '#ef4444',
    FOLLOW_UP_PENDIENTE: '#f97316',
    RECORDATORIO: '#00F6ED',
    LEAD_RECHAZADO_ZONA: '#c12139',
    SERVICIO_PENDIENTE: '#f97316',
    SERVICIO_PENDIENTE_AGRUPADO: '#f97316',
    LIFECYCLE_PENDIENTE: '#00F6ED'
  };
  return colors[tipo] || '#6b7280';
};

export default {
  getNotificaciones,
  getNotificacionesCount,
  getCountCategorias,
  marcarLeida,
  marcarTodasLeidas,
  getNotifIcon,
  getNotifColor
};